export const defaultImg =
  "https://cdn.vectorstock.com/i/preview-1x/65/30/default-image-icon-missing-picture-page-vector-40546530.jpg";
export const defaultCurrency = {
  title: "United States | English",
  currency: "usd",
  country: "US",
  language: "en",
};

export const defaultLoginAsUser = {
  loginMessage:
    "If you already have an account, login to have a fast and easy checkout.",
  loginLabel: "Company ID:",
};
export const defaultWLSRoles = [
  "wl_meeting_free",
  "wl_shop_free",

  "wl_standard_plan",
  "wl_pro_plan",
  "wl_premium_plan",
  "wl_affiliate",

  "Customer",
  "wlshop",

  // Planes nuevos PXch
  "pxch_intro",
  "pxch_basic",
  "pxch_premium",
  "pxch_pro",
];
export const wlsRollName = [
  "wl_meeting_free",
  "wl_shop_free",
  "Customer",
  "wlshop",
  "wl_standard_plan",
  "wl_pro_plan",
  "wl_premium_plan",
  "wl_affiliate",

  // Planes nuevos PXch
  "pxch_intro",
  "pxch_basic",
  "pxch_premium",
  "pxch_pro",
];
export const wlsPremiumRollName = [
  "wl_shop_free",
  "wlshop",
  "wl_meeting_free",
  "wl_premium_plan",
  "wl_pro_plan",
  "wl_standard_plan",

  // Planes nuevos PXch
  "pxch_intro",
  "pxch_basic",
  "pxch_premium",
  "pxch_pro",
];
export const wlsFreeRoles = ["wl_meeting_free", "wl_shop_free"];
export const wlsNoMeetService = ["wl_affiliate"];

export const wlsFreeSandboxRoles = ["wl_meeting_free", "wl_shop_free"];
export const wlsNewPlans = [
  "wl_affiliate",
  "wl_premium_plan",
  "wl_pro_plan",
  "wl_standard_plan",

  // Planes nuevos PXch
  "pxch_intro",
  "pxch_basic",
  "pxch_premium",
  "pxch_pro",
];

export const wlsDisabledRoles = ["wl_shop_on_hold"];
export const wlsChildPlanRoles = ["wl_plan_child"];
// Enterprise y family NO se validan por rol desde el front: su plan y sus
// funcionalidades se resuelven en `commons/plan` (resolveUserPlan +
// planFeatures.json), que acepta tanto el rol Auth0 como el plan_code de la
// suscripción. Ver `useIsEnterpriseAccount` y `useCanUseFamilyPlan`.

export const superAdminRoleName = "admin";

export const ulrsTutorialVideo = {
  streamingSetUp: "",
  uploadPresentation: "",
};

export const creditsCheckoutMode = "embed"; // "embed" | "redirect"

export const smartLinkRoles = ["wl_pro_plan", "admin"];

// Usuarios con acceso garantizado a secciones específicas, independientemente
// de su rol Auth0. Útil para cuentas locales / de prueba que necesitan testear
// una vista sin tener el rol asignado. Los IDs son Auth0 sub completos
// (ej: "auth0|abc123"). Ver .claude/commands/access-validation.md.
/**
 * auth0|6871bacd71a0a83edb950d47 -> pxchcorporate
 * auth0|68b8d26ec2bf18233ab041c5 -> dapa2896
 * auth0|6879305018868a2b1597a853 -> steve.mypxch
 * auth0|66f188163af333787c700ef0 -> steve.workinglive
 */
export const USERS_GRANTED_ALWAYS = {
  smart_links: [
    "auth0|6871bacd71a0a83edb950d47",
    "auth0|68b8d26ec2bf18233ab041c5",
  ],
  //Family Plan management (parent view) - QA / cuentas de prueba -
  family_plan: [
    // "auth0|...",
  ],
  my_avatar: [
    "auth0|687b1ecc77ffa496a332f38a",
    "auth0|68b8d26ec2bf18233ab041c5",
    "auth0|6879305018868a2b1597a853",
    "auth0|66f188163af333787c700ef0",
  ],
  //available for new functionality - testing purposes -
  new_feature: [
    "auth0|68b8d26ec2bf18233ab041c5",
    "auth0|6879305018868a2b1597a853",
    "auth0|66f188163af333787c700ef0",
    "auth0|699cfb367a2376b5db175ece", //usuario free
  ],
  //AI video creation tools (Studio/Media/Voice) - under maintenance for everyone except testers -
  ai_videos: [
    "auth0|68b8d26ec2bf18233ab041c5",
    "auth0|6879305018868a2b1597a853",
  ],
};
